module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/lake/Room_lake_02slide_02.png";